// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"89":"9c94a21b","462":"910be1ec","579":"260ecf6c"}[chunkId] + ".chunk.css";
};